// SEO assessments - import TextLengthAssessment first to avoid initialization errors.
import TextLengthAssessment from './seo/TextLengthAssessment';

// Readability assessments.
import ParagraphTooLongAssessment from './readability/ParagraphTooLongAssessment';
import SentenceBeginningsAssessment from './readability/SentenceBeginningsAssessment';
import SentenceLengthInTextAssessment from './readability/SentenceLengthInTextAssessment';
import TransitionWordsAssessment from './readability/TransitionWordsAssessment';
import RelatedKeywordsAssessment from './readability/RelatedKeywordsAssessment';

// SEO assessments.
import InternalLinksAssessment from './seo/InternalLinksAssessment';
import IntroductionKeywordAssessment from './seo/IntroductionKeywordAssessment';
import KeyphraseDensityAssessment from './seo/KeywordDensityAssessment';
import MetaDescriptionKeywordAssessment from './seo/MetaDescriptionKeywordAssessment';
import MetaDescriptionLengthAssessment from './seo/MetaDescriptionLengthAssessment';
import OutboundLinksAssessment from './seo/OutboundLinksAssessment';
import PageTitleWidthAssessment from './seo/PageTitleWidthAssessment';
import SingleH1Assessment from './seo/SingleH1Assessment';
import SubheadingsKeywordAssessment from './seo/SubHeadingsKeywordAssessment';
import SlugKeywordAssessment from './seo/UrlKeywordAssessment';
import ImageCountAssessment from './seo/ImageCountAssessment';
import KeyphraseAssessment from './seo/KeyphraseAssessment';
import SingleTitleAssessment from './seo/SingleTitleAssessment';
import UrlLengthAssessment from './seo/UrlLengthAssessment';
import NumberInMetaTitleAssessment from './seo/NumberInMetaTitleAssessment';
import TextImagesAssessment from './seo/TextImagesAssessment';
import MetaTitleKeywordAssessment from './seo/MetaTitleKeywordAssessment';
import SchemaAssessment from './seo/SchemaAssessment';
import RelatedKeywordsDensityAssessment from './seo/RelatedKeywordsDensityAssessment';
import InvalidCharactersInUrl from './seo/InvalidCharactersInUrl';
import FAQsStructureDataAssessment from './seo/FAQsStructureDataAssessment';

const readability = {
  ParagraphTooLongAssessment,
  SentenceBeginningsAssessment,
  SentenceLengthInTextAssessment,
  TransitionWordsAssessment,
  RelatedKeywordsAssessment
};

// We expose the deprecated assessments for backwards compatibility.
const seo = {
  ImageCountAssessment,
  NumberInMetaTitleAssessment,
  InternalLinksAssessment,
  TextImagesAssessment,
  MetaTitleKeywordAssessment,
  IntroductionKeywordAssessment,
  SingleTitleAssessment,
  UrlLengthAssessment,
  KeyphraseDensityAssessment,
  MetaDescriptionKeywordAssessment,
  MetaDescriptionLengthAssessment,
  OutboundLinksAssessment,
  PageTitleWidthAssessment,
  SingleH1Assessment,
  SubheadingsKeywordAssessment,
  TextLengthAssessment,
  SlugKeywordAssessment,
  KeyphraseAssessment,
  SchemaAssessment,
  RelatedKeywordsDensityAssessment,
  InvalidCharactersInUrl,
  FAQsStructureDataAssessment
};

export {readability, seo};
